(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('ASTBMainController', MsoMainController);

   // AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
    MsoMainController.$inject = ['$scope', '$state', 'Mso', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider'];

    function MsoMainController ($scope, $state, Mso, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider ) {

        $scope.tabData   = [
            {
                heading: 'Channel Map',
                route:   'astbmso-main.headend',
                class: 'btn-lg'
            },
            {
                heading: 'Office',
                route:   'astbmso-main.office',
                class: 'btn-lg'
            },
            {
                heading: 'MSO',
                route:   'astbmso-main.mso',
                class: 'btn-lg'
            }

        ];

        $scope.go = function(route){
            $state.go(route);
        };


        $scope.go('astbmso-main.headend');

    }
   /* function AstbBillingController ($scope, Principal, LoginService, $state) {

    }*/
})();
